<template>
  <div class="fb-root d-print-none">
    <transition name="fb-pop">
      <div v-if="open" class="fb-panel" role="dialog" aria-label="Festy Bot">
        <div class="fb-head">
          <div>
            <div class="fb-title">Festy Bot</div>
            <div class="fb-sub">Pide por chat a cualquier comercio</div>
          </div>
          <v-btn icon small dark title="Empezar de nuevo" @click="reset"><v-icon small>mdi-restart</v-icon></v-btn>
          <v-btn icon small dark title="Cerrar" @click="open = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <div ref="log" class="fb-log">
          <div v-for="(m, i) in messages" :key="i" :class="['fb-msg', m.role]">
            <div class="fb-bubble" v-text="m.text"></div>
            <div v-if="m.orders && m.orders.length" class="fb-orders">
              <div v-for="o in m.orders" :key="o.id">Pedido <b>#{{ o.id }}</b> · {{ o.store }} · {{ money(o.total) }}</div>
              <router-link v-if="loggedIn" to="/orders">Ver mis pedidos</router-link>
            </div>
          </div>
          <div v-if="busy" class="fb-msg bot"><div class="fb-bubble fb-typing"><i></i><i></i><i></i></div></div>
        </div>
        <form class="fb-input" @submit.prevent="send">
          <input ref="input" v-model="draft" type="text" maxlength="500" placeholder="Escribe qué quieres pedir…" :disabled="busy" autocomplete="off">
          <v-btn icon color="#c91d20" type="submit" :disabled="!draft.trim() || busy" aria-label="Enviar"><v-icon>mdi-send</v-icon></v-btn>
        </form>
      </div>
    </transition>
    <button class="fb-fab" type="button" :aria-expanded="open ? 'true' : 'false'" @click="toggle">
      <v-icon dark>{{ open ? 'mdi-close' : 'mdi-robot-happy-outline' }}</v-icon>
      <span v-if="!open">Pedir por chat</span>
    </button>
  </div>
</template>

<script>
import Parse from 'parse'

const WELCOME = 'Hola, soy Festy Bot. Dime qué se te antoja o de qué comercio quieres pedir y te armo el pedido.'

function sessionId () {
  try {
    let id = window.localStorage.getItem('festyBotSession')
    if (!id) {
      id = 'web-' + Math.random().toString(36).slice(2) + Date.now().toString(36)
      window.localStorage.setItem('festyBotSession', id)
    }
    return id
  } catch (e) {
    return 'web-' + Date.now().toString(36)
  }
}

export default {
  name: 'FestyBot',
  data: () => ({
    open: false,
    busy: false,
    draft: '',
    messages: [{ role: 'bot', text: WELCOME }],
    sid: sessionId()
  }),
  computed: {
    loggedIn () { return !!Parse.User.current() }
  },
  mounted () { window.addEventListener('festy-bot-open', this.show) },
  beforeDestroy () { window.removeEventListener('festy-bot-open', this.show) },
  methods: {
    show () {
      if (!this.open) this.toggle()
    },
    money: n => '$' + String(Math.round(Number(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
    toggle () {
      this.open = !this.open
      if (this.open && window.festyTrack) window.festyTrack('bot_open', { source: 'widget' })
      if (this.open) this.$nextTick(() => this.$refs.input && this.$refs.input.focus())
    },
    scroll () {
      this.$nextTick(() => { const el = this.$refs.log; if (el) el.scrollTop = el.scrollHeight })
    },
    async send () {
      const text = this.draft.trim()
      if (!text || this.busy) return
      this.draft = ''
      this.messages.push({ role: 'user', text })
      this.busy = true
      this.scroll()
      try {
        const r = await Parse.Cloud.run('botMessage', { channel: 'web', sessionId: this.sid, text, lang: document.documentElement.lang === 'en' ? 'en' : 'es' })
        this.messages.push({ role: 'bot', text: r.reply, orders: r.orders })
      } catch (e) {
        this.messages.push({ role: 'bot', text: 'No pude responder ahora mismo. Intenta de nuevo en un momento.' })
      } finally {
        this.busy = false
        this.scroll()
        this.$nextTick(() => this.$refs.input && this.$refs.input.focus())
      }
    },
    async reset () {
      try { await Parse.Cloud.run('botReset', { channel: 'web', sessionId: this.sid }) } catch (e) { /* sin historial que borrar */ }
      this.messages = [{ role: 'bot', text: WELCOME }]
    }
  }
}
</script>

<style scoped>
.fb-root { position: fixed; left: 16px; bottom: 16px; z-index: 30; font-family: inherit; }
.fb-fab { display: inline-flex; align-items: center; gap: 8px; background: #17150e; color: #fff; border: 0; border-radius: 999px; padding: 12px 18px 12px 14px; font: 600 15px/1 inherit; cursor: pointer; box-shadow: 0 12px 30px -10px rgba(0, 0, 0, .55); }
.fb-fab:hover { background: #2a271a; }
.fb-panel { position: absolute; left: 0; bottom: 60px; width: min(380px, calc(100vw - 32px)); height: min(560px, calc(100vh - 120px)); background: #fff; border-radius: 18px; box-shadow: 0 24px 60px -20px rgba(0, 0, 0, .5); display: flex; flex-direction: column; overflow: hidden; }
.fb-head { display: flex; align-items: center; gap: 4px; background: #17150e; color: #fff; padding: 12px 10px 12px 16px; }
.fb-head > div:first-child { flex: 1; min-width: 0; }
.fb-title { font-weight: 700; font-size: 16px; line-height: 1.2; }
.fb-sub { font-size: 12px; color: #b4b09c; }
.fb-log { flex: 1; overflow-y: auto; padding: 14px 12px; background: #f6f5ef; display: flex; flex-direction: column; gap: 8px; }
.fb-msg { display: flex; flex-direction: column; max-width: 88%; }
.fb-msg.user { align-self: flex-end; align-items: flex-end; }
.fb-msg.bot { align-self: flex-start; align-items: flex-start; }
.fb-bubble { padding: 9px 12px; border-radius: 14px; font-size: 14px; line-height: 1.45; white-space: pre-wrap; word-break: break-word; }
.fb-msg.user .fb-bubble { background: #f3d923; color: #17150e; border-bottom-right-radius: 4px; }
.fb-msg.bot .fb-bubble { background: #fff; border: 1px solid #e3e0d2; border-bottom-left-radius: 4px; }
.fb-orders { margin-top: 4px; font-size: 12px; background: #dcf0e5; color: #146b46; border-radius: 10px; padding: 8px 10px; }
.fb-orders a { color: #146b46; font-weight: 600; }
.fb-typing { display: flex; gap: 4px; align-items: center; padding: 12px 14px; }
.fb-typing i { width: 6px; height: 6px; border-radius: 50%; background: #b4b09c; animation: fb-blink 1.2s infinite; }
.fb-typing i:nth-child(2) { animation-delay: .2s; }
.fb-typing i:nth-child(3) { animation-delay: .4s; }
@keyframes fb-blink { 0%, 80%, 100% { opacity: .3; } 40% { opacity: 1; } }
.fb-input { display: flex; align-items: center; gap: 4px; padding: 8px 8px 8px 14px; border-top: 1px solid #e3e0d2; background: #fff; }
.fb-input input { flex: 1; min-width: 0; border: 0; outline: 0; font-size: 14px; padding: 8px 0; background: transparent; }
.fb-pop-enter-active, .fb-pop-leave-active { transition: opacity .18s ease, transform .18s ease; }
.fb-pop-enter, .fb-pop-leave-to { opacity: 0; transform: translateY(10px); }
@media (max-width: 600px) { .fb-fab span { display: none; } .fb-fab { padding: 12px; } }
</style>
